import React from "react";

import { FormError, OverrideMessages } from "@/components/errors";
import { attachmentBuilder } from "@/components/Files/attachmentBuilder";
import { Progress } from "@/eworkitComponents";

import { errorKey } from "./service";
import { IRenderer } from "./types";

import "./_attachment-progress.scss";

interface Props extends IRenderer {
  className?: string;
  overrideMessages?: OverrideMessages;
}

const ProgressAttachmentRenderer: React.FunctionComponent<Props> = React.memo((props: Props) => {
  const { className, file, error, progress, overrideMessages } = props;
  const key = errorKey(error);

  const errorVisible = error && !error.canceled && key;

  return (
    <div className={className}>
      {file && !errorVisible && (
        <div className="attachment-progress__progress-wrapper">
          <Progress match={progress} size="sm" />
        </div>
      )}
      {errorVisible && (
        <div className="attachment-progress__error-wrapper">
          <FormError error={key} overrideMessages={overrideMessages} />
        </div>
      )}
    </div>
  );
});

export const ProgressAttachment = attachmentBuilder<Props>(ProgressAttachmentRenderer);
